import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ThfDynamicModule, ThfModalModule, ThfPageModule, ThfWidgetModule } from '@totvs/thf-ui';

import { ThfPageDynamicDetailComponent } from './thf-page-dynamic-detail.component';

/**
 * @description
 *
 * MÃ³dulo do template do thf-page-dynamic-detail.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,

    ThfDynamicModule,
    ThfModalModule,
    ThfPageModule,
    ThfWidgetModule
  ],
  declarations: [
    ThfPageDynamicDetailComponent
  ],
  exports: [
    ThfPageDynamicDetailComponent
  ]
})
export class ThfPageDynamicDetailModule { }
